import { render, staticRenderFns } from "./PurchaseApprovalForm.vue?vue&type=template&id=47af415c&scoped=true"
import script from "./PurchaseApprovalForm.vue?vue&type=script&lang=js"
export * from "./PurchaseApprovalForm.vue?vue&type=script&lang=js"
import style0 from "./PurchaseApprovalForm.vue?vue&type=style&index=0&id=47af415c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af415c",
  null
  
)

export default component.exports